import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'gl-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    standalone: false
})
export class SearchInputComponent implements OnChanges, OnInit {
  @Output() public searchChange: EventEmitter<string>;
  @HostBinding('class.select') @Input() public select: boolean;
  @Input() public value: string = '';
  public placeholder;
  public searchString: string;

  constructor(private translate: TranslateService) {
    this.searchChange = new EventEmitter();
    this.placeholder = this.translate.instant('search') as string;
  }

  ngOnInit(): void {
    if (this.value) {
      this.searchString = this.value;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && changes.value.currentValue !== undefined) {
      this.searchString = changes.value.currentValue || '';
    }
  }

  public onChange() {
    this.searchChange.emit(this.searchString);
  }
}
